/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useMemo } from 'react';
import SavableDropdownField from '../../components/SavableDropdownField';
import { saveResolution } from '../../actions/TicketActions';
import { useAppDispatch, useAppSelector } from '../../reducers/zorseGrrTagging';
import { jsx as _jsx } from "react/jsx-runtime";
function ResolutionField() {
  const dispatch = useAppDispatch();
  const resolutions = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticketExternalProperties.resolutions);
  const isCloseTicketChecked = useAppSelector(({
    zorseGrrTagging: state
  }) => state.panelState.closeTicketCheckedByTicketId.get(state.ticket.id, true));
  const isSaving = useAppSelector(({
    zorseGrrTagging: state
  }) => state.actionStates.isSavingResolution);
  const ticket = useAppSelector(({
    zorseGrrTagging: state
  }) => state.ticket);
  const options = useMemo(() => resolutions.map(obj => ({
    text: obj.name,
    value: obj.id
  })).sortBy(obj => obj.text).toArray(), [resolutions]);
  return /*#__PURE__*/_jsx(SavableDropdownField, {
    isRequired: isCloseTicketChecked,
    isSaving: isSaving,
    labelLangPath: "app.panel.body.fields.labels.resolution",
    onOptionSelected: id => dispatch(saveResolution(ticket.id, resolutions.find(obj => obj.id === id))),
    options: options,
    placeholderLangPath: "app.panel.body.fields.placeholders.choose",
    value: ticket.resolution && ticket.resolution.id
  });
}
export default ResolutionField;